import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, unref as _unref, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "add-intent-modal" }
const _hoisted_2 = { class: "edit-title-container" }
const _hoisted_3 = { class: "field" }
const _hoisted_4 = {
  key: 0,
  class: "help is-danger"
}

import { required, maxLength } from '@vuelidate/validators';
import { computed, ref } from 'vue';
import useVuelidate from '@vuelidate/core';
import VuelidateUtil from '@shared/util/vuelidateUtil';


export default /*@__PURE__*/_defineComponent({
  __name: 'FaqAddIntentModal',
  emits: ["create", "close"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const intentTitle = ref('');
const intentNameInput = ref<HTMLInputElement | null>(null);

const validations = {
  intentTitle: {
    required,
    validIntentName: (value: string) => value.search(/[<>*%&:\\$]/) === -1,
    maxLength: maxLength(50),
  },
};

const $v = useVuelidate(validations, { intentTitle });
const isTitleRequiredInvalid = computed(() => VuelidateUtil.isRequiredInvalid($v, 'intentTitle'));

function close() {
  $v.value.$reset();
  intentTitle.value = '';
  emit('close');
}

function createIntent() {
  if ($v.value.$invalid) {
    return;
  }
  emit('create', intentTitle.value);
  close();
}

const errorMessage = computed(() => {
  if ($v.value.intentTitle.required.$invalid) {
    return 'Name must not be empty';
  } else if ($v.value.intentTitle.validIntentName.$invalid) {
    return 'Name must not contain <, >, *, %, &, :, \\, $';
  } else if ($v.value.intentTitle.maxLength.$invalid) {
    return 'Name must not be longer than 50 characters';
  }

  return '';
});

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_button_group = _resolveComponent("n-button-group")!
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_n_modal, {
      onCancel: _cache[2] || (_cache[2] = ($event: any) => (close()))
    }, {
      title: _withCtx(() => _cache[3] || (_cache[3] = [
        _createElementVNode("p", { class: "modal-card-title" }, "Add a new intent", -1)
      ])),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _cache[4] || (_cache[4] = _createElementVNode("label", {
            for: "intent-name-input",
            class: "label"
          }, "Name", -1)),
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              ref_key: "intentNameInput",
              ref: intentNameInput,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((intentTitle).value = $event)),
              label: "Intent name",
              class: "input",
              type: "text",
              placeholder: "Enter Intent Name",
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_unref($v).intentTitle.$touch())),
              onKeyup: _withKeys(createIntent, ["enter"])
            }, null, 544), [
              [_vModelText, intentTitle.value]
            ]),
            (errorMessage.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(errorMessage.value), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      buttons: _withCtx(() => [
        _createVNode(_component_n_button_group, null, {
          default: _withCtx(() => [
            _createVNode(_component_n_button, {
              variant: "primary",
              onClick: createIntent,
              disabled: _unref($v).$invalid
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("Add")
              ])),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_n_button, {
              onClick: close,
              variant: "primary--outline"
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("Cancel")
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})